import { createSlice } from "@reduxjs/toolkit";
import { english } from "../language/en";
import { gujarati } from "../language/gu";
import { set } from "date-fns";
import { henglish } from "../language/homeEn";
import { hgujarati } from "../language/homeGu";


type LanguageDataType = typeof english; 
export const authSlice = createSlice({
    name:"auth",
    initialState:{
        token:"",
        setUserDet:{},
        isSignedIn:false,
        userAreaDetails:"",
        userDetails:{},
        applicationId:"",
        language:english,
        formLanguage: gujarati,
        homeLanguage:henglish,
        experienceData:[],
        workPerformance:[],
        constructionData:[],
        refId: null,
        applicationCounts:null,
        mainLoader: false,
    },
    reducers: {
        OnSignIn : (state,action)=>{
           state.isSignedIn  = true
           state.token = action.payload
           
        },
        onSignOut : (state, action) =>{
          state.isSignedIn = false
          state.token = ""
        },
        setToken : (state,action)=>{
            state.token = action.payload
        },
        setUserDet:(state,action)=>{
            state.userDetails = action.payload
        },
        setUserAreaDet:(state,action)=>{
            state.userAreaDetails = action.payload
        },
        setApplicationId:(state,action)=>{
            state.applicationId = action.payload
        },
        setLanguage:(state,action)=>{
            state.language = action.payload === "gujarati" ? gujarati : english
        },
        setFormLanguage:(state,action)=>{
            state.formLanguage =  action.payload === "gujarati" ? gujarati : english 
        },
        setHomeLanguage:(state,action)=>{
            state.homeLanguage =  action.payload === "gujarati" ? hgujarati : henglish 
        },
        setExperienceData:(state,action)=>{
            state.experienceData = action.payload
        },
        setWorkPerformance:(state,action)=>{
            state.workPerformance = action.payload
        },
        setConstructionData:(state,action)=>{
            state.constructionData = action.payload
        },
        setApplicationCount:(state,action)=>{
            state.applicationCounts = action.payload
        },
        setMainLoader:(state,action)=>{
            state.mainLoader = action.payload
        },
        
    }

})


// export default authSlice.reducer
export const { OnSignIn, onSignOut,setHomeLanguage, setToken ,setLanguage,setUserDet,setUserAreaDet , setApplicationId ,setExperienceData , 
    setWorkPerformance ,setConstructionData , setFormLanguage,setApplicationCount, setMainLoader} = authSlice.actions

export default authSlice.reducer